import { render } from "./NewHistoryItem.vue?vue&type=template&id=1b39d8c8&scoped=true&ts=true"
import script from "./NewHistoryItem.vue?vue&type=script&lang=ts"
export * from "./NewHistoryItem.vue?vue&type=script&lang=ts"

import "./NewHistoryItem.vue?vue&type=style&index=0&id=1b39d8c8&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b39d8c8"]])

export default __exports__